import { render, staticRenderFns } from "./TemplateListingBase.vue?vue&type=template&id=188c1719&scoped=true&"
import script from "./TemplateListingBase.vue?vue&type=script&lang=js&"
export * from "./TemplateListingBase.vue?vue&type=script&lang=js&"
import style0 from "../../Style/template-listing-base.scss?vue&type=style&index=0&id=188c1719&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c1719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188c1719')) {
      api.createRecord('188c1719', component.options)
    } else {
      api.reload('188c1719', component.options)
    }
    module.hot.accept("./TemplateListingBase.vue?vue&type=template&id=188c1719&scoped=true&", function () {
      api.rerender('188c1719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplateListingBase.vue"
export default component.exports